import { render, staticRenderFns } from "./HolidaysAll.vue?vue&type=template&id=a08a8bac&scoped=true&"
import script from "./HolidaysAll.vue?vue&type=script&lang=ts&"
export * from "./HolidaysAll.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08a8bac",
  null
  
)

export default component.exports